var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDepressionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E87722"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9749 11.5666C14.9749 11.5666 13.6291 9.49165 10.9374 9.49165C8.24577 9.49165 6.6416 12.0042 6.6416 14.5125C6.6416 17.0208 8.86245 18.7333 9.73329 19.6083C10.5125 20.3875 13.6749 22.7666 14.7041 23.6291C14.8624 23.7583 15.0874 23.7583 15.2416 23.6291C16.2708 22.7666 19.4333 20.3917 20.2124 19.6083C21.0874 18.7333 23.3041 17.025 23.3041 14.5125C23.3041 12 21.7041 9.49165 19.0083 9.49165C16.3125 9.49165 14.9749 11.5666 14.9749 11.5666Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepressionIcon);
export default __webpack_public_path__ + "static/media/depressionIcon.98d2ab236ed4f2b74cdcc73603b1634a.svg";
export { ForwardRef as ReactComponent };